/* Collection page v2 (conversion test)
   - product card: swatch switching, quick-add size tray, add to bag -> cart drawer
   - mobile toolbar: sticky offset under header, sort bridge, filter sheet groups, live counts
   - header: collapsible description, scroll active chip into view
   Works with facets.js (AJAX filtering replaces #ProductGridContainer) via event delegation. */
(function () {
  'use strict';
  if (window.__collectionV2) return;
  window.__collectionV2 = true;

  var SIZE_ABBR = {
    'x-small': 'XS', 'xsmall': 'XS', 'extra small': 'XS', 'xs': 'XS',
    'small': 'S', 's': 'S',
    'medium': 'M', 'm': 'M',
    'large': 'L', 'l': 'L',
    'x-large': 'XL', 'xlarge': 'XL', 'extra large': 'XL', 'xl': 'XL',
    'xx-large': '2XL', 'xxlarge': '2XL', 'xxl': '2XL', '2x-large': '2XL', '2xl': '2XL',
    'xxx-large': '3XL', 'xxxl': '3XL', '3x-large': '3XL', '3xl': '3XL',
    '4x-large': '4XL', '4xl': '4XL',
    'one size': 'OS', 'os': 'OS'
  };

  function abbr(s) {
    if (s == null) return '';
    var k = String(s).trim().toLowerCase();
    return SIZE_ABBR[k] || String(s);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function t(key, fallback) {
    var s = window.collectionV2Strings || {};
    return s[key] || fallback;
  }
  function prefersHover() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
  }

  /* ------------------------------------------------------------------ cards */
  function cardVariants(card) {
    if (card.__variants) return card.__variants;
    var el = card.querySelector('[data-pcard-variants]');
    var data = [];
    if (el) {
      try { data = JSON.parse(el.textContent || '[]'); } catch (e) { data = []; }
    }
    card.__variants = Array.isArray(data) ? data : [];
    return card.__variants;
  }

  function sizesFor(card, color) {
    return cardVariants(card).filter(function (v) {
      return !(color && v.c != null && v.c !== color);
    });
  }

  function renderSizes(card, color) {
    var list = sizesFor(card, color);
    var tray = card.querySelector('[data-pcard-sizes]');
    var avail = card.querySelector('[data-pcard-avail]');
    var anyAvail = list.some(function (v) { return v.a; });

    if (tray) {
      var html = '';
      if (list.length === 1 && list[0].s == null) {
        html = '<button type="button" class="pcard__size pcard__size--single" data-variant-id="' + esc(list[0].id) + '"' +
          (list[0].a ? '' : ' disabled') + '>' + esc(list[0].a ? t('add', 'Add to Bag') : t('sold_out', 'Sold out')) + '</button>';
        tray.classList.add('pcard__qa-sizes--single');
      } else {
        tray.classList.remove('pcard__qa-sizes--single');
        list.forEach(function (v) {
          html += '<button type="button" class="pcard__size" data-variant-id="' + esc(v.id) + '" aria-label="' + esc(v.s) + '"' +
            (v.a ? '' : ' disabled') + '>' + esc(abbr(v.s)) + '</button>';
        });
      }
      tray.innerHTML = html;
    }
    if (avail) {
      var ah = '';
      list.forEach(function (v) {
        if (v.s == null) return;
        ah += '<span' + (v.a ? '' : ' class="is-out"') + '>' + esc(abbr(v.s)) + '</span>';
      });
      avail.innerHTML = ah;
    }
    if (list.length) {
      card.classList.toggle('pcard--soldout', !anyAvail);
      var badge = card.querySelector('[data-pcard-soldout-badge]');
      if (badge) badge.hidden = anyAvail;
      var toggle = card.querySelector('[data-pcard-qa-toggle]');
      if (toggle) toggle.hidden = !anyAvail;
      if (!anyAvail) toggleTray(card, false);
    }
  }

  function switchColor(card, sw) {
    var color = sw.getAttribute('data-color');
    card.querySelectorAll('.pcard__swatch').forEach(function (b) {
      var on = b === sw;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    card.setAttribute('data-color', color);

    var url = sw.getAttribute('data-url');
    if (url) card.querySelectorAll('[data-pcard-url]').forEach(function (a) { a.setAttribute('href', url); });

    var img = card.querySelector('.pcard__img--first');
    var src = sw.getAttribute('data-img');
    if (img && src && img.getAttribute('src') !== src) {
      var srcset = sw.getAttribute('data-srcset') || '';
      var probe = new Image();
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
        img.setAttribute('src', src);
        requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
      };
      img.classList.add('is-swapping');
      probe.onload = finish;
      probe.onerror = finish;
      if (srcset) probe.srcset = srcset;
      probe.sizes = img.getAttribute('sizes') || '';
      probe.src = src;
      setTimeout(finish, 1500);
    }
    card.classList.add('no-hover-img');
    var sub = card.querySelector('[data-pcard-color-name]');
    if (sub) sub.textContent = color;
    renderSizes(card, color);
  }

  function toggleTray(card, open) {
    if (!card) return;
    card.classList.toggle('is-qa-open', !!open);
    var media = card.querySelector('.pcard__media');
    if (media && (media.scrollTop || media.scrollLeft)) { media.scrollTop = 0; media.scrollLeft = 0; }
    var tg = card.querySelector('[data-pcard-qa-toggle]');
    if (tg) tg.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !prefersHover()) {
      var msg = card.querySelector('[data-pcard-msg]');
      if (msg) msg.textContent = '';
    }
  }
  function closeAllTrays(except) {
    document.querySelectorAll('.pcard.is-qa-open').forEach(function (c) {
      if (c !== except) toggleTray(c, false);
    });
  }

  var adding = false;
  function addToCart(card, btn) {
    if (adding || !btn || btn.disabled) return;
    adding = true;
    var id = btn.getAttribute('data-variant-id');
    var msg = card.querySelector('[data-pcard-msg]');
    if (msg) msg.textContent = '';
    btn.classList.remove('is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    var cart = document.querySelector('cart-drawer');
    var hasDrawer = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
    if (hasDrawer) {
      /* Shopify expects one comma-separated list, not repeated fields */
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json || json.status) throw new Error((json && (json.description || json.message)) || 'cart-error');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var single = btn.classList.contains('pcard__size--single');
        var original = btn.innerHTML;
        if (single) btn.textContent = t('added', 'Added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (single) btn.innerHTML = original;
        }, 1800);

        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-card-v2', productVariantId: id }); } catch (e) { /* noop */ }
        }
        document.dispatchEvent(new CustomEvent('collection-v2:added', { detail: { variantId: id, item: json } }));

        if (hasDrawer && json.sections) {
          /* the drawer refocuses this element on close. Never hand it the size button: by then the tray has slid
             out of the clipped image box, and focusing it scrolls the box (image pushed up, tray stuck visible) */
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(card.querySelector('.pcard__title a') || card.querySelector('.pcard__link') || card);
          cart.classList.remove('is-empty'); /* same as the theme's product form: host must not stay "empty" after an add */
          try {
            cart.renderContents(json);
          } catch (renderErr) {
            /* item is already in the cart; never show a failure for a drawer re-render problem */
            if (window.console) console.error('[collection-v2] cart drawer render failed', renderErr);
            if (typeof cart.open === 'function') cart.open(btn);
          }
          setTimeout(function () { toggleTray(card, false); }, 250);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        if (window.console) console.error('[collection-v2] quick add failed', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (msg) msg.textContent = t('error', "Couldn't add to bag. Please try again.");
        setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
      })
      .then(function () {
        adding = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.pcard__swatch');
    if (sw) {
      e.preventDefault();
      var c0 = sw.closest('.pcard');
      if (c0) switchColor(c0, sw);
      return;
    }
    var tg = e.target.closest('[data-pcard-qa-toggle]');
    if (tg) {
      e.preventDefault();
      var c1 = tg.closest('.pcard');
      closeAllTrays(c1);
      toggleTray(c1, !c1.classList.contains('is-qa-open'));
      return;
    }
    var cl = e.target.closest('[data-pcard-qa-close]');
    if (cl) {
      e.preventDefault();
      toggleTray(cl.closest('.pcard'), false);
      return;
    }
    var sz = e.target.closest('.pcard__size[data-variant-id]');
    if (sz) {
      e.preventDefault();
      if (sz.disabled || sz.getAttribute('aria-disabled') === 'true') return;
      addToCart(sz.closest('.pcard'), sz);
      return;
    }
    if (!e.target.closest('.pcard__qa')) closeAllTrays(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllTrays(null);
  });
  /* the image box clips its content; if the browser scrolls it (focus on a tray button, find-in-page), snap it back */
  document.addEventListener('scroll', function (e) {
    var m = e.target;
    if (m && m.classList && m.classList.contains('pcard__media') && (m.scrollTop || m.scrollLeft)) { m.scrollTop = 0; m.scrollLeft = 0; }
  }, true);

  /* hover image: only fetched when a pointer (or keyboard focus) actually reaches the card */
  function hydrateSecond(card) {
    if (!card || card.__hyd) return;
    card.__hyd = true;
    var img = card.querySelector('.pcard__img--second[data-src]');
    if (!img) return;
    img.addEventListener('load', function () { card.classList.add('has-second'); }, { once: true });
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    img.setAttribute('src', img.dataset.src);
  }
  document.addEventListener('mouseover', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('.pcard') : null;
    if (c) hydrateSecond(c);
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('.pcard') : null;
    if (c) hydrateSecond(c);
  });

  /* ---------------------------------------------------------------- toolbar */
  function initToolbar() {
    var bar = document.querySelector('[data-fv2]');
    if (!bar || bar.__init) return;
    bar.__init = true;

    /* keep the sticky toolbar below the header while the header is visible/sticky */
    var headerSection = document.querySelector('.shopify-section-header');
    function updateTop() {
      var h = 0;
      if (headerSection) {
        var sticky = headerSection.classList.contains('shopify-section-header-sticky');
        var hidden = headerSection.classList.contains('shopify-section-header-hidden');
        if (sticky && !hidden) {
          var hdr = headerSection.querySelector('.header-top') || headerSection.querySelector('sticky-header') || headerSection;
          h = Math.round(hdr.getBoundingClientRect().height);
        }
      }
      document.documentElement.style.setProperty('--cv2-toolbar-top', h + 'px');
    }
    updateTop();
    if (headerSection && window.MutationObserver) {
      new MutationObserver(updateTop).observe(headerSection, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', updateTop);

    /* shadow when stuck */
    if (window.IntersectionObserver) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:relative;height:1px;margin-top:-1px;pointer-events:none;';
      bar.parentNode.insertBefore(sentinel, bar);
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-stuck', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: [0], rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
    }

    /* sort select in the bar drives the hidden sort radios inside the sheet (facets.js listens to the form) */
    bar.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-fv2-sort]');
      if (!sel) return;
      var lbl = bar.querySelector('[data-fv2-sort-label]');
      if (lbl && sel.selectedIndex > -1) lbl.textContent = sel.options[sel.selectedIndex].text;
      var form = document.getElementById('FacetFiltersFormMobile');
      var radio = form ? Array.prototype.find.call(form.querySelectorAll('input[name="sort_by"]'), function (r) { return r.value === sel.value; }) : null;
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      }
    });

    /* accordion groups in the sheet (state lives on the .js-filter wrapper so AJAX re-renders keep it) */
    function syncGroups() {
      bar.querySelectorAll('[data-fv2-group]').forEach(function (g) {
        var head = g.querySelector('[data-fv2-group-head]');
        if (head) head.setAttribute('aria-expanded', g.getAttribute('data-open') === 'true' ? 'true' : 'false');
      });
    }
    bar.addEventListener('click', function (e) {
      var head = e.target.closest('[data-fv2-group-head]');
      if (!head) return;
      var group = head.closest('[data-fv2-group]');
      if (!group) return;
      var open = group.getAttribute('data-open') !== 'true';
      group.setAttribute('data-open', open ? 'true' : 'false');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    bar.addEventListener('keydown', function (e) {
      var head = e.target.closest('[data-fv2-group-head]');
      if (head && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        head.click();
      }
    });

    /* live count: facets.js rewrites the first .mobile-facets__count; mirror the number into the sheet button */
    function syncCount() {
      var n = bar.querySelector('[data-fv2-n]');
      var val = n ? n.textContent.trim() : '';
      bar.querySelectorAll('[data-fv2-count]').forEach(function (el) { el.textContent = val; });
    }
    var metaCount = bar.querySelector('.mobile-facets__count');
    if (metaCount && window.MutationObserver) {
      new MutationObserver(function () { syncCount(); syncGroups(); }).observe(metaCount, { childList: true, subtree: true, characterData: true });
    }
    var sheetForm = document.getElementById('FacetFiltersFormMobile');
    if (sheetForm && window.MutationObserver) {
      new MutationObserver(syncGroups).observe(sheetForm, { childList: true, subtree: true });
    }
    /* hide the active-filter row when it has no chips (facets.js rewrites its innerHTML) */
    var activeRow = bar.querySelector('.fv2__active');
    function syncActive() {
      if (activeRow) activeRow.classList.toggle('is-empty', !activeRow.querySelector('.active-facets__button'));
    }
    if (activeRow && window.MutationObserver) {
      new MutationObserver(syncActive).observe(activeRow, { childList: true, subtree: true });
    }
    syncCount();
    syncGroups();
    syncActive();

    /* lift the toolbar above the sticky header while the sheet is open */
    var details = bar.querySelector('details.fv2__details');
    if (details) {
      details.addEventListener('toggle', function () {
        bar.classList.toggle('is-open', details.open);
        if (details.open) { syncGroups(); return; }
        /* safety net: once the sheet is closed, never leave the page scroll-locked (unless another mobile drawer is open) */
        if (!document.querySelector('[data-breakpoint="mobile"] > details[open]')) document.body.classList.remove('overflow-hidden-mobile');
      });
    }
  }

  /* ----------------------------------------------------------------- header */
  function initHeader() {
    var desc = document.querySelector('[data-ch2-desc]');
    if (desc && !desc.__init) {
      desc.__init = true;
      var text = desc.querySelector('.ch2__desc-text');
      var btn = desc.querySelector('.ch2__desc-toggle');
      if (text && btn) {
        desc.setAttribute('data-collapsed', 'true');
        if (text.scrollHeight > text.clientHeight + 2) {
          btn.hidden = false;
        } else {
          desc.removeAttribute('data-collapsed');
        }
        btn.addEventListener('click', function () {
          var collapsed = desc.getAttribute('data-collapsed') === 'true';
          desc.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? t('read_less', 'Read less') : t('read_more', 'Read more');
          btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        });
      }
    }
    var active = document.querySelector('.ch2__chips .ch2__chip.is-active');
    if (active) {
      var wrap = active.closest('.ch2__chips');
      if (wrap && wrap.scrollWidth > wrap.clientWidth + 4) {
        wrap.scrollLeft = Math.max(0, active.offsetLeft - 16);
      }
    }
  }

  function init() {
    initToolbar();
    initHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
